'use client'

import React from 'react'
import ReviewSlide from './ReviewSlide'
import { Review } from '@partment/types'

interface ClientReviewSlideProps {
  initialReviews: Review[]
}

export default function ClientReviewSlide({
  initialReviews,
}: ClientReviewSlideProps) {
  return <ReviewSlide initialReviews={initialReviews} />
}
